export const Tooltip = () => {
  return (
    <svg
      width="173"
      height="77"
      viewBox="0 0 173 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_266_7213)">
        <rect
          width="141"
          height="38"
          rx="8"
          transform="matrix(-1 0 0 1 157 8)"
          fill="#242424"
        />
        <path
          d="M32.334 32.1367C30.3584 32.1367 28.9023 30.9541 28.8477 29.3203H30.584C30.6387 30.1201 31.3975 30.6943 32.334 30.7012C33.4414 30.6943 34.2412 29.8945 34.2344 28.8008C34.2412 27.666 33.4209 26.8662 32.2793 26.8594C31.5068 26.8525 30.9463 27.126 30.6387 27.707H28.9844L29.5859 22.1016H35.4375V23.5918H31.0488L30.748 26.2168H30.8438C31.2266 25.7861 31.9443 25.4717 32.7578 25.4648C34.5967 25.4717 35.9639 26.8389 35.957 28.7461C35.9639 30.7217 34.4736 32.1367 32.334 32.1367ZM47.4004 20.8574V28.1309H45.8828V26.4219H43.3945V27.3789H37.584V21.7871H43.3945V22.7441H45.8828V20.8574H47.4004ZM39.0195 30.8379C39.0059 29.334 40.6123 28.4521 43.2168 28.459C45.835 28.4521 47.4346 29.334 47.4414 30.8379C47.4346 32.3418 45.835 33.2031 43.2168 33.2031C40.6123 33.2031 39.0059 32.3418 39.0195 30.8379ZM39.1016 26.1621H41.8906V22.9902H39.1016V26.1621ZM40.5234 30.8379C40.5166 31.6035 41.501 32.0273 43.2168 32.0273C44.9463 32.0273 45.9238 31.6035 45.9238 30.8379C45.9238 30.0381 44.9463 29.6279 43.2168 29.6211C41.501 29.6279 40.5166 30.0381 40.5234 30.8379ZM43.3945 25.1914H45.8828V23.9473H43.3945V25.1914ZM63.7383 26.5312V27.7617H58.8438V28.8008C61.0518 28.9443 62.3643 29.71 62.3711 30.9883C62.3643 32.4102 60.751 33.2031 58.0918 33.2031C55.3916 33.2031 53.7852 32.4102 53.7852 30.9883C53.7852 29.71 55.0977 28.9375 57.3398 28.7939V27.7617H52.4727V26.5312H63.7383ZM53.0195 24.7676C55.2891 24.5557 56.7725 23.6328 57.0254 22.6211H53.498V21.4043H62.7266V22.6211H59.165C59.4111 23.6396 60.8809 24.5557 63.2051 24.7676L62.6719 25.9707C60.4229 25.7383 58.7617 24.8428 58.0918 23.5918C57.4219 24.8428 55.7812 25.7383 53.5391 25.9707L53.0195 24.7676ZM55.3301 30.9883C55.3232 31.6719 56.2939 32.0479 58.0918 32.041C59.8623 32.0479 60.8398 31.6719 60.8535 30.9883C60.8398 30.3047 59.8623 29.9424 58.0918 29.9355C56.2939 29.9424 55.3232 30.3047 55.3301 30.9883ZM68.127 30.1543V28.7324L72.4062 22.1016H74.6211V28.6914H75.9199V30.1543H74.6211V32H72.9258V30.1543H68.127ZM69.9453 28.6914H72.9531V24.125H72.8438L69.9453 28.623V28.6914ZM87.2812 20.8574V28.1309H85.7637V26.4219H83.2754V27.3789H77.4648V21.7871H83.2754V22.7441H85.7637V20.8574H87.2812ZM78.9004 30.8379C78.8867 29.334 80.4932 28.4521 83.0977 28.459C85.7158 28.4521 87.3154 29.334 87.3223 30.8379C87.3154 32.3418 85.7158 33.2031 83.0977 33.2031C80.4932 33.2031 78.8867 32.3418 78.9004 30.8379ZM78.9824 26.1621H81.7715V22.9902H78.9824V26.1621ZM80.4043 30.8379C80.3975 31.6035 81.3818 32.0273 83.0977 32.0273C84.8271 32.0273 85.8047 31.6035 85.8047 30.8379C85.8047 30.0381 84.8271 29.6279 83.0977 29.6211C81.3818 29.6279 80.3975 30.0381 80.4043 30.8379ZM83.2754 25.1914H85.7637V23.9473H83.2754V25.1914ZM99.3125 20.8574V33.2305H97.7812V20.8574H99.3125ZM89.4277 26.1211C89.4209 23.4551 90.7812 21.7598 92.6543 21.7598C94.5068 21.7598 95.874 23.4551 95.8809 26.1211C95.874 28.8076 94.5068 30.4961 92.6543 30.4961C90.7812 30.4961 89.4209 28.8076 89.4277 26.1211ZM90.8906 26.1211C90.8906 28.0215 91.6084 29.1221 92.6543 29.1289C93.6934 29.1221 94.4043 28.0215 94.4043 26.1211C94.4043 24.2344 93.6934 23.127 92.6543 23.127C91.6084 23.127 90.8906 24.2344 90.8906 26.1211ZM115.09 20.8574V33.2168H113.641V26.9141H112.246V32.5879H110.852V21.0898H112.246V25.6973H113.641V20.8574H115.09ZM104.836 30.332V22.3203H109.457V23.5508H106.367V29.0469C107.707 29.0332 108.814 28.9648 110.072 28.7324L110.182 29.9766C108.685 30.2773 107.393 30.3184 105.67 30.332H104.836ZM120.928 22.8262C120.928 24.3779 121.933 25.8477 123.84 26.4492L123.02 27.6387C121.687 27.1875 120.729 26.2852 120.189 25.1367C119.656 26.4492 118.658 27.4814 117.236 27.9805L116.416 26.791C118.405 26.1006 119.403 24.4531 119.41 22.6895V21.5137H120.928V22.8262ZM118.098 30.8516C118.098 29.3887 119.704 28.5205 122.281 28.5273C124.838 28.5205 126.417 29.3887 126.424 30.8516C126.417 32.3486 124.838 33.2031 122.281 33.2031C119.704 33.2031 118.098 32.3486 118.098 30.8516ZM119.615 30.8516C119.615 31.6172 120.586 32 122.281 32C123.97 32 124.92 31.6172 124.92 30.8516C124.92 30.127 123.97 29.7168 122.281 29.7168C120.586 29.7168 119.615 30.127 119.615 30.8516ZM124.783 28.2539V20.8574H126.301V23.8652H128.023V25.123H126.301V28.2539H124.783ZM133.082 24.3711C133.075 26.2783 134.224 28.4521 136.172 29.3613L135.324 30.5645C133.93 29.9082 132.897 28.582 132.344 27.0371C131.783 28.7324 130.703 30.1816 129.281 30.8652L128.393 29.6758C130.361 28.7393 131.558 26.4287 131.564 24.3711V23.332H128.871V22.0742H135.666V23.332H133.082V24.3711ZM136.814 33.2168V20.8574H138.332V25.6699H140.232V26.9414H138.332V33.2168H136.814ZM143.295 22.1016L143.145 29.0879H141.6L141.436 22.1016H143.295ZM141.312 31.043C141.306 30.4688 141.791 29.9971 142.379 29.9902C142.946 29.9971 143.432 30.4688 143.432 31.043C143.432 31.6309 142.946 32.1094 142.379 32.1094C141.791 32.1094 141.306 31.6309 141.312 31.043Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M137.293 52.2929C137.683 52.6834 138.317 52.6834 138.707 52.2929L145 46H131L137.293 52.2929Z"
          fill="#242424"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M134.464 49.4645C136.417 51.4171 139.583 51.4171 141.536 49.4645L149 42H127L134.464 49.4645Z"
          fill="#242424"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_266_7213"
          x="0"
          y="0"
          width="173"
          height="77"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_266_7213"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_266_7213"
            result="effect2_dropShadow_266_7213"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_266_7213"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
